import type { ReactNode } from 'react';

interface SettingsBannerProps {
    children: ReactNode;
    action?: ReactNode;
}

export default function SettingsBanner({ children, action }: SettingsBannerProps) {
    return (
        <div className="flex items-start gap-3 rounded-xl border border-[#bfdbfe] bg-[#eff6ff] px-4 py-3 mb-6">
            <svg
                className="w-4 h-4 text-[#3b82f6] flex-shrink-0 mt-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
            </svg>
            <div className="flex-1 min-w-0">
                <p className="text-xs text-[#1e40af] leading-relaxed">{children}</p>
                {action && <div className="mt-2">{action}</div>}
            </div>
        </div>
    );
}
